import { useMemo } from "react";
import { useAppSelector } from "./store";
import { getCurrentUser } from "../reducers/authSlice";

function useAuth() {
  const user = useAppSelector(getCurrentUser);
// useMemo
  return useMemo(() => user, [user]);
}

export default useAuth;
